// Module
var code = "<div v-if=\"isMobile\"> <footer class=\"footer\"> <div class=\"container-footer text-center\"> <span class=\"text-muted font-size-50 mb-10-px\"></span> </div> </footer> </div>";
// Exports
export default code;